{
  "de": {
    "imports": {
      "searchPlaceholder": "Name...",
      "selectedCount": "kein Element ausgewählt | {count} ausgewählt | {count} ausgewählt",
      "cancel": "Abbrechen",
      "confirm": "Auswählen",
      "contentList": {
        "leaveFolder": "Zurück aus Ordner „{name}“",
        "openFolder": "Ordner „{name}“ öffnen"
      },
      "loadMore": "Mehr laden",
      "submitFailed": "Import fehlgeschlagen. Bitte versuche es erneut.",
      "toTeach": {
        "modalTitle": "to teach Arbeitsblätter importieren",
        "menuItem": "Import von to teach",
        "importedBadge": "Importiert von to teach",
        "link": {
          "title": "Konto verknüpfen",
          "body": "Dein Konto ist noch nicht mit to teach verknüpft. Verbinde dein Konto, um deine to teach Inhalte bei fobizz zu nutzen.",
          "confirm": "Zu to teach"
        },
        "worksheets": {
          "tabLabel": "Dein to teach Konto",
          "accountLink": "Dein to teach Konto",
          "searchPlaceholder": "to teach Arbeitsblätter durchsuchen",
          "empty": "Keine to teach Arbeitsblätter gefunden.",
          "errorLoading": "Deine to teach Arbeitsblätter konnten nicht geladen werden.",
          "batchQueuedFlash": "Dein Arbeitsblatt wird im Hintergrund importiert. | Dein Arbeitsblatt wird im Hintergrund importiert. | {count} Arbeitsblätter werden im Hintergrund importiert."
        }
      }
    }
  }
}
